import {
  ProfileInteractionEntrySchema as ContractProfileInteractionEntrySchema,
  ProfileInteractionsResponseSchema as ContractProfileInteractionsResponseSchema,
} from '@sweetistics/contracts';
import type { z } from 'zod';

export const ProfileInteractionEntrySchema = ContractProfileInteractionEntrySchema;

export const ProfileInteractionsResponseSchema = ContractProfileInteractionsResponseSchema;

export type ProfileInteractionEntry = z.infer<typeof ProfileInteractionEntrySchema>;
export type ProfileInteractionsResponse = z.infer<typeof ProfileInteractionsResponseSchema>;

export type ProfileInteractionsResponseInput = z.input<typeof ProfileInteractionsResponseSchema>;
export type ProfileInteractionsResponseOutput = z.output<typeof ProfileInteractionsResponseSchema>;

export function serializeProfileInteractionsResponse(
  payload: ProfileInteractionsResponseInput
): ProfileInteractionsResponseOutput {
  return ProfileInteractionsResponseSchema.parse(payload);
}
